import React from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";

import { SectionHeading, EmailVerificationInfo } from "../";

const MyAccount = ({ email, style, appsAPI }) => (
  <div style={style}>
    <SectionHeading title="Account information" icon="user" />

    <div style={{ padding: "0 8px" }}>
      {/*<h2>*/}
      {/*<img*/}
      {/*src={picture}*/}
      {/*alt={"profile"}*/}
      {/*style={{ width: "50px", borderRadius: "50%" }}*/}
      {/*/>{" "}*/}
      {/*{name}*/}
      {/*</h2>*/}
      <EmailVerificationInfo appsAPI={appsAPI} />
      <NavLink to={"/app/verifyemail"}>(Re)Verify email address</NavLink>
    </div>
  </div>
);

MyAccount.propTypes = {
  style: PropTypes.object,
  email: PropTypes.string.isRequired,
  appsAPI: PropTypes.func.isRequired,
  // name: PropTypes.string.isRequired,
  picture: PropTypes.string.isRequired
};
export default MyAccount;



// WEBPACK FOOTER //
// ./src/components/my_account/MyAccount.jsx